import CreateEmailTypes from "./createEmailTypes";

const typeDefs = [CreateEmailTypes];

export default typeDefs;
